import * as React from "react";
import { func } from "../../../utils";
const Loading = () => {
  return (
    <div className="a-preloader">
      <img src={func.getStaticImg("illustration/loading.svg")} id="preloader" />
    </div>
  );
};

export default Loading;
